class ABGrecaptchaLoader {
    constructor(params) {
        if (ABGrecaptchaLoader.isInWindow()) {
            throw new Error('Grecaptcha already loaded.');
        } else if (!('key' in params)) {
            throw new Error('No key provided. Creation cancelled.');
        } else {
            this.key = params.key;
            this.scriptUrl = `https://www.google.com/recaptcha/api.js?render=${this.key}`;
            this.doLog = params.doLog || false;
            window.ABGrecaptchaLoaderInstance = this;
        }
    }
    
    _log(message = 'Error', data = {}) {
        console.log (message, data);
    }
    
    _loadScript() {
        const data = {};
        if (ABGrecaptchaLoader.isInWindow()) {
            data.status = 'loaded';
        } else {
            data.promise = globalFunctions.loadScript(this.scriptUrl);
            data.status = 'requested';
        }
        return data;
    }
    
    _processRequest(data, onSuccess, onError) {
        if (data.status === 'requested') {
            data.promise
                .then(data => {
                    onSuccess(data)
                })
                .catch((err, data) => {
                    onError(err, data);  
                });
        } else if (data.status === 'loaded') {
            onSuccess(data);
        }
    }
    
    static isInWindow() {
        return 'grecaptcha' in window && typeof grecaptcha !== 'undefined';
    }
    
    static load(params = {}, onSuccess = function(){}, onError) {
        if (!onError) {
            onError = function() {
                $(document).trigger('is:errorModal', {
                    title: '',
                    text: 'Не удалось отправить форму. Пожалуйста, перезагрузите страницу и попробуйте снова'});
            }
        }
        new ABGrecaptchaLoader(params);
        const request = ABGrecaptchaLoaderInstance._loadScript();
        ABGrecaptchaLoaderInstance._processRequest(request, onSuccess, onError);
    }
}
